import { render, staticRenderFns } from "./OJsonTextArea.vue?vue&type=template&id=d0754c50&scoped=true&"
import script from "./OJsonTextArea.vue?vue&type=script&lang=js&"
export * from "./OJsonTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0754c50",
  null
  
)

export default component.exports